/* Silk & Blue: the BUNDLE10 code is turned off, so hide its line in product descriptions. */
(function () {
  function clean() {
    document.querySelectorAll('li').forEach(function (li) {
      if (/BUNDLE10/i.test(li.textContent) && !li.querySelector('li')) {
        li.remove();
      }
    });
  }
  clean();
  new MutationObserver(clean).observe(document.documentElement, { childList: true, subtree: true });
})();
